import { ExportableAdgColorTypes, getColor } from "./adg-colors";

export type ValidAngles =
    | "0"
    | "45"
    | "90"
    | "135"
    | "180"
    | "225"
    | "270"
    | "315";

export const getGradient = (
    angle?: ValidAngles,
    color1?: ExportableAdgColorTypes,
    color2?: ExportableAdgColorTypes
): string => {
    if (angle && color1 && color2) {
        return `linear-gradient(${angle}deg, ${getColor(color1)}, ${getColor(
            color2
        )})`;
    }
    return "";
};
